export enum Animal {
    Lion = 1,
    Elephant,
    Baboon,
    Giraffe,
    Cheetah,
    Warthog,
    Zebra,
    Jackal,
    EgyptianDuck,
    BlackRhino,
    WaterBuck,
    Hippo,
    YellowBilledStork,
    WaterThickKnee,
    TreeClimbingLion,
    YellowBarbet,
    SouthernGroundHornbill,
    DwarfMongoose,
    SpottedHyena,
    Buffalo,
    Leopard,
    Wildebeest,
    VervetMonkey,
    BlueMonkey,
    BlackWhiteColobusMonkey,
    Flamingo
}

export enum Rarity {
    Common = 1,
    Uncommon,
    Rare
}

export class Entry {
  constructor(options?: { animal: Animal; rarity: Rarity; }) {
      if (options) {
          this.animal = options.animal;
          this.rarity = options.rarity;
      }
  }
  animal: Animal;
  rarity: Rarity;
}

export class Entries {
  constructor(options?: { entries: Entry[]; }) {
      if (options) {
          this.entries = options.entries;
      }
  }
  entries: Entry[];
}

// [Tooltip Text, Image Link, Alt Desc for Image]
export let AnimalData = new Map<number, [string, string, string]>([

  [Animal.Lion, ['Lion', '100x100/female-lion.jpg', 'Fierce Female Lion']],
  [Animal.Elephant, ['Elephant', '100x100/african-elephant.jpg', 'African Elephant']],
  [Animal.Baboon, ['Baboon', '100x100/baboon-and-baby.jpg', 'Baboon with a baby on its back']],
  [Animal.Giraffe, ['Giraffe', '100x100/giraffe-headshot.jpg', 'Giraffe']],
  [Animal.Cheetah, ['Cheetah', '100x100/cheetah.jpg', 'Cheetah under a tree']],
  [Animal.Warthog, ['African Warthog', '100x100/african-warthog-sm.jpg', 'African Warthog']],
  [Animal.Zebra, ['Zebra', '100x100/zebra.jpg', 'Zebra']],
  [Animal.Jackal, ['Jackal', '100x100/jackal.jpg', 'Jackal with ears perked']],
  [Animal.EgyptianDuck, ['Egyptian Duck', '100x100/egyptian-duck.jpg', 'Egyptian Duck']],
  [Animal.BlackRhino, ['Black Rhino', '100x100/black-rhino-icon.jpg', 'Adult Black Rhino']],
  [Animal.WaterBuck, ['Water Buck', '100x100/water-buck.jpg', 'Adult Water Buck']],
  [Animal.Hippo, ['Hippo', '100x100/hippo-smile.jpg', 'Adult Hippo in Water']],
  [Animal.YellowBilledStork, ['Yellow Billed Stork', '100x100/yellow-billed-stork.jpg', 'Adult Yellow Billed Stork']],
  [Animal.WaterThickKnee, ['Water Thick Knee', '100x100/water-thick-knee.jpg', 'Water Thick Knee Bird Walking']],
  [Animal.TreeClimbingLion, ['Tree Climbing Lion', '100x100/female-lion.jpg', 'Tree Climbing Lion']],
  [Animal.YellowBarbet, ['Yellow Barbet Bird', '100x100/yellow-barbet.jpg', 'Yellow Barbet Bird Resting on Tree']],
  [Animal.SouthernGroundHornbill, ['Southern Ground Hornbill Bird', '100x100/southern-ground-hornbill.jpg', 'Adult Southern Ground Hornbill Bird Walking Amongst the Grass']],
  [Animal.DwarfMongoose, ['Dwarf Mongoose', '100x100/dwarf-mongoose.jpg', 'Dwarf Mongoose Crawling on Termite Hill']],
  [Animal.SpottedHyena, ['Spotted Hyena', '100x100/spotted-hyena.jpg', 'Adult Spotted Hyena in the Mud']],
  [Animal.Buffalo, ['Buffalo', '100x100/arusha-buffalo.jpg', 'Adult African Buffalo showing off its horns']],
  [Animal.Leopard, ['Leopard', '100x100/leopard.jpg', 'Adult leopard resting on tree branch']],
  [Animal.Wildebeest, ['Wildebeest', '100x100/wildebeest.jpg', 'Adult wildebeest grazing in a grassy field']],
  [Animal.VervetMonkey, ['Vervet Monkey', '100x100/vervet-monkey.jpg', 'Adult vervet monkey sitting on a fence']],
  [Animal.BlueMonkey, ['Blue Monkey', '100x100/blue-monkey.jpg', 'Close up of an adult Blue Monkey']],
  [Animal.BlackWhiteColobusMonkey, ['Black and White Colobus Monkey', '100x100/black-and-white-colobus-monkey.jpg', 'Close up of an adult Black and White Colobus Monkey']],
  [Animal.Flamingo, ['Flamingo', '100x100/flamingo.jpg', 'Adult flamngo flapping its wings']],
]);
